import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import axios from "axios";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import {
  addMaterialAction,
  deleteMaterialAction,
  getAllMaterialAction,
  setAddMaterialResponse,
  setAllMaterialAction,
  updateMaterialAction,
} from "../reducers/materialSlice";
import {
  checkCustomerStorageAction,
  createContractAction,
  getContractListAction,
  getSingleContractAction,
  setCheckCustomerStorageResponseAction,
  setContractListAction,
  setCreateContractResponseAction,
  setSingleContractAction,
  updateContractAction,
} from "../reducers/contractStorageSlice";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

/* -------------------------------------------------------------------------- */
/* API Config                                                                 */
/* -------------------------------------------------------------------------- */

const V2_CONFIG = {
  baseURL: process.env.REACT_APP_BASE_URL_V2,
};

function* getContractListSaga(payload: any): any {
  yield put(setLoaderAction(true));
  const { leadId, page, limit } = payload?.payload;
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `storage/leads/${leadId}/contracts?page=${page}&limit=${limit}`,
      "",
      V2_CONFIG,
    );
    if (res?.data) {
      yield put(setContractListAction(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* createContractSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const { leadId, customerName, ...newPayload } = payload?.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "post",
      `storage/leads/${leadId}/contracts`,
      "",
      V2_CONFIG,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setCreateContractResponseAction(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setCreateContractResponseAction(false));
  }
  yield put(setLoaderAction(false));
}

function* updateContractSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const {
      leadId,
      contractId,
      createdAt,
      updatedAt,
      contractNo,
      id,
      customerId,
      customer,
      customerName,
      units,
      storageLeadId,
      ...newPayload
    } = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "put",
      `storage/leads/${leadId}/contracts/${contractId}`,
      "",
      V2_CONFIG,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setCreateContractResponseAction(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setCreateContractResponseAction(false));
  }
  yield put(setLoaderAction(false));
}

function* deleteMaterialSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `client/materials/${payload?.payload?.id}`,
      "",
      V2_CONFIG,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddMaterialResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddMaterialResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* checkCustomerStorageSaga(payload: any): any {
  yield put(setLoaderAction(true));
  const { leadId } = payload?.payload;
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `/storage/removal-transition/preview?leadId=${leadId}`,
      "",
      V2_CONFIG,
    );

    if (res?.data) {
      yield put(setCheckCustomerStorageResponseAction(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* getSingleContractSaga(payload: any): any {
  yield put(setLoaderAction(true));
  const { id } = payload?.payload;
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `storage/contracts/${id}`,
      "",
      V2_CONFIG,
    );

    if (res?.data) {
      yield put(setSingleContractAction(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

export function* watchContractStorage() {
  yield takeLatest<any>(getContractListAction, getContractListSaga);
  yield takeLatest<any>(createContractAction, createContractSaga);
  yield takeLatest<any>(updateContractAction, updateContractSaga);
  yield takeLatest<any>(checkCustomerStorageAction, checkCustomerStorageSaga);
  // yield takeLatest<any>(deleteContractAction, deleteContractSaga);
  yield takeLatest<any>(getSingleContractAction, getSingleContractSaga);
}
